var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-introduction pa-5 white"},[_c('v-container',[_c('div',{staticClass:"intro mb-6 text-center text-md-left"},[_vm._t("title")],2),_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }